// ─── Formatting helpers ─────────────────────────────────────────────────────

export const fmtDate = (d) => {
  if (!d) return '';
  const date = new Date(d);
  return date.toLocaleDateString('en-GB', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
  });
};

export const fmtRelative = (d) => {
  if (!d) return '';
  const diff = Math.floor((Date.now() - new Date(d)) / 1000);
  if (diff < 60)   return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400)return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

export const fmtDeadline = (d) => {
  if (!d) return '';
  const diff = Math.ceil((new Date(d) - new Date()) / 86400000);
  if (diff < 0)  return 'Overdue';
  if (diff === 0) return 'Today';
  if (diff === 1) return 'Tomorrow';
  if (diff < 7)  return `${diff}d`;
  if (diff < 30) return `${Math.ceil(diff / 7)}w`;
  return `${Math.ceil(diff / 30)}mo`;
};

export const pct = (cur, tar) => tar > 0 ? Math.min(100, Math.round((cur / tar) * 100)) : 0;
export const fmt = (n) => n >= 1000 ? `${(n / 1000).toFixed(1)}k` : String(n ?? 0);

export const goalHealth = (goal, milestones) => {
  if (!goal.deadline) return null;
  const now = new Date();
  const deadline = new Date(goal.deadline);
  if (deadline < now) return 'overdue';
  const created = new Date(goal.created_at || Date.now() - 30 * 86400000);
  const totalDays = Math.max(1, (deadline - created) / 86400000);
  const elapsed = Math.max(0, (now - created) / 86400000);
  const timeProgress = Math.min(100, (elapsed / totalDays) * 100);
  const goalMs = milestones.filter(m => m.goal_id === goal.id);
  const progress = goal.type === 'quantitative'
    ? pct(goal.metric_current, goal.metric_target)
    : goalMs.length > 0 ? Math.round((goalMs.filter(m => m.done).length / goalMs.length) * 100) : 0;
  if (progress >= 100) return 'done';
  const ratio = timeProgress > 5 ? progress / timeProgress : 1;
  if (ratio >= 0.65) return 'on-track';
  if (ratio >= 0.35) return 'drifting';
  return 'at-risk';
};

// ─── Effort parser ──────────────────────────────────────────────────────────
export const parseEffort = (effort) => {
  if (!effort) return 60;
  const m = effort.match(/(\d+\.?\d*)\s*(m|min|h|hr|d|day)/i);
  if (!m) return 60;
  const v = parseFloat(m[1]);
  const u = m[2].toLowerCase();
  if (u.startsWith('m')) return Math.round(v);
  if (u.startsWith('h')) return Math.round(v * 60);
  if (u.startsWith('d')) return Math.round(v * 480);
  return 60;
};

export const fmtMinutes = (mins) => {
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return h > 0 ? (m > 0 ? `${h}h ${m}m` : `${h}h`) : `${m}m`;
};

export const timeFromMin = (min) => {
  const h = Math.floor(min / 60);
  const m = min % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};
